import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackendShellRoutingModule } from './backend-shell.routing';

@NgModule({
  imports: [CommonModule, BackendShellRoutingModule],
})
export class BackendShellModule {}
